import {tourneesGraffitiConstants} from './tourneesGraffiti.constants';
import {tourneesGraffitiService} from './tourneesGraffiti.service';

export const tourneesGraffitiActions = {
    fetchTourneesGraffiti,
    deleteTourneeGraffiti,
    clear,
};

function fetchTourneesGraffiti() {
    return dispatch => {
        dispatch({ type: tourneesGraffitiConstants.TOURNEES_GRAFFITI_FETCH_REQUEST });
        tourneesGraffitiService.fetchTourneesGraffiti()
            .then(
                items => dispatch({ type: tourneesGraffitiConstants.TOURNEES_GRAFFITI_FETCH_SUCCESS, items }),
                error => dispatch({ type: tourneesGraffitiConstants.TOURNEES_GRAFFITI_FETCH_FAILURE, error: error.toString() })
            );
    };
}

function deleteTourneeGraffiti(id) {
    return dispatch => {
        dispatch({ type: tourneesGraffitiConstants.TOURNEES_GRAFFITI_DELETE_REQUEST });
        tourneesGraffitiService.deleteTourneeGraffiti(id)
            .then(
                deletedId => dispatch({ type: tourneesGraffitiConstants.TOURNEES_GRAFFITI_DELETE_SUCCESS, id: deletedId }),
                error => dispatch({ type: tourneesGraffitiConstants.TOURNEES_GRAFFITI_DELETE_FAILURE, error: error.toString() })
            );
    };
}

function clear() {
    return { type: tourneesGraffitiConstants.TOURNEES_GRAFFITI_CLEAR };
}
